
import { RevButton } from '@ds/components/Button'
import { RevPaper } from '@ds/components/Paper'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

import { ROUTES } from '@router'

import translations from './SwapConfirmation.translations'

export default {
  components: {
    RevPaper,
    IconCheckInCircle,
    RevButton,
  },
  props: {
    product: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    delivery: {
      type: String,
      default: '',
    },
    showDelivery: {
      type: Boolean,
      default: true,
    },
    buybackTitle: {
      type: String,
      required: true,
    },
    buybackPrice: {
      type: String,
      required: true,
    },
    additionalWordings: {
      type: Array,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    ROUTES: () => ROUTES,
    buyDetails() {
      if (!this.showDelivery) {
        return this.$t(translations.buyDetailsWithoutDelivery, {
          product: this.product,
          price: this.price,
        })
      }

      return this.$t(translations.buyDetails, {
        product: this.product,
        price: this.price,
        delivery: this.delivery,
      })
    },

    wordings() {
      const defaultWordings = [
        {
          title: this.$t(translations.buyNow),
          paragraphs: [this.buyDetails],
        },
      ]

      return [...defaultWordings, ...this.additionalWordings]
    },
  },
  methods: {
    complete(to, type) {
      this.$emit('completed', { to })
      this.handleDataLayer(type)
    },
    handleDataLayer(type) {
      this.$emit('tracking', { type })
    },
  },
}
